import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
} from '@mui/material';

const ReusableMenu = ({
  anchorEl,
  open,
  onClose,
  menuItems = [],
  sx = {},
  anchorOrigin,
  transformOrigin,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{
        sx: {
          width: 200,
          borderRadius: '8px',
          border: '1px solid #8C8C8C',
          boxShadow: '0px 2px 8px 0px #0000001A',
          p: 1,
        },
      }}
      MenuListProps={{
        disablePadding: true,
        
      }}
      sx={{...sx}}
    >
      {menuItems.map((item, index) => (
        <MenuItem
            key={index}
            onClick={item.onClick}
            autoFocus={false}
            autoFocusItem={false}
            sx={{
                px: 0,
                py: {xs: 0, md:1},
                gap: 1,
                fontSize: 14,
                borderRadius: '8px',
                color: '#333',
                '&:hover': {
                    backgroundColor: '#f5f5f5',
                },
                minHeight: '35px',
            }}
        >
          {item.icon && (
            <ListItemIcon
              sx={{
                minWidth: 32,
                color: '#666',
                borderRadius: '8px',
              }}
            >
              {item.icon}
            </ListItemIcon>
          )}
          <Typography variant="body2" sx={{ px: 1 }}>
            {item.label}
          </Typography>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ReusableMenu;
